module.exports = __webpack_public_path__ + "img/c44.684ced01.png";